// extracted by mini-css-extract-plugin
export default {"text":"Text_text__sOP0I"};